module.exports = __webpack_public_path__ + "static/media/icon-cross.97a56fd5.svg";